import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

console.log('[GovToolsPro] index.tsx starting...');

const rootElement = document.getElementById('root');
console.log('[GovToolsPro] Root element:', rootElement ? 'found' : 'NOT FOUND');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  console.log('[GovToolsPro] ReactDOM root created, rendering App...');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('[GovToolsPro] App render called');
} else {
  console.error('[GovToolsPro] FATAL: Root element not found!');
}
